export function FormatTime(seconds, format) {
	// eslint-disable-next-line no-var
	var hours, mins, secs;
	format = format || 'hh:mm:ss';

	hours = Math.floor(seconds / 3600);
	mins = Math.floor((seconds % 3600) / 60);
	secs = Math.floor((seconds % 3600) % 60);

	hours = hours < 10 ? ("0" + hours) : hours;
	mins = mins < 10 ? ("0" + mins) : mins;
	secs = secs < 10 ? ("0" + secs) : secs;
	return format.replace('hh', hours).replace('mm', mins).replace('ss', secs);
}
